"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const useNewTab = (onClose) => {
    const [newTab, setNewTab] = (0, react_1.useState)(null);
    const [isAwaitingClose, setIsAwaitingClose] = (0, react_1.useState)(false);
    const closeNewTab = () => {
        newTab && newTab.close();
    };
    (0, react_1.useEffect)(() => {
        if (newTab) {
            //poll for close event
            setIsAwaitingClose(true);
            const interval = setInterval(async () => {
                if (newTab.closed) {
                    clearInterval(interval);
                    setIsAwaitingClose(false);
                    await onClose();
                }
            }, 500);
        }
    }, [newTab, onClose]);
    return { newTab, setNewTab, isAwaitingClose, closeNewTab };
};
exports.default = useNewTab;
